import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import "./PageLayout.css";

export default function PageLayout({ title, children, wide = false }) {
  return (
    <div className="page-layout">
      <Navbar />
      <main className="page-main">
        <div className={`container ${wide ? "page-container-wide" : ""}`}>
          <Link to="/" className="page-back">
            ← Back to Home
          </Link>
          <h1 className="page-title">{title}</h1>
          <div className={`page-content ${wide ? "page-content-wide" : ""}`}>
            {children}
          </div>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
